import { createApp } from 'vue'
import router from './router/router'
import '../src/assets/css/style.css';
import App from './App.vue'
import store from "@/store";
const app = createApp(App);

app.use(store).use(router);

app.directive('validate-password', {
    beforeMount(el, binding) {
        el.addEventListener('input', () => {
            const value = el.value;
            const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!_"@*?()\-=+&^%$])[A-Za-z\d!_"@*?()\-=+&^%$]{8,20}$/;
            const isValid = regex.test(value);

            if (value.length >= 8 && value.length <= 10) {
                el.style.borderColor = 'orange';
            } else if (value.length > 10 && value.length <= 20) {
                el.style.borderColor = 'green';
            } else {
                el.style.borderColor = 'red';
            }

            if (binding.value) {
                binding.value(isValid);
            }

            if (!value) {
                el.style.borderColor = '';
            }
        });
    },
});

app.directive('validate-phone', {
    beforeMount(el, binding) {
        const validatePhone = () => {
            const regex = binding.value.regex;
            const isValid = regex.test(el.value);

            if (binding.value.callback) {
                binding.value.callback(isValid);
            }

            if (!isValid && el.value.length > 0) {
                el.style.borderColor = 'red';
            } else {
                el.style.borderColor = '';
            }
        };

        el.addEventListener('input', validatePhone);
    },
});

app.directive('validate-email', {
    beforeMount(el, binding) {
        el.addEventListener('input', () => {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const isValid = regex.test(el.value);
            if (binding.value) {
                binding.value(isValid);
            }
            if (!isValid && el.value.length > 0) {
                el.style.borderColor = 'red';
            } else {
                el.style.borderColor = '';
            }
        });
    },
});

app.mount('#app');